module.exports = __webpack_public_path__ + "static/media/13ITC2.8b2062fe.jpg";